/* unplugin-vue-components disabled */import { render } from "./FlipCardImageDialog.vue?vue&type=template&id=97a72a24&ts=true"
import script from "./FlipCardImageDialog.vue?vue&type=script&lang=ts"
export * from "./FlipCardImageDialog.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__